import { SOMATIC_KEYS } from "../../../../shared";
import { OptionsWithBackground } from "../../../../shared";
import background from "./bg.png";

const data = [
  { displayValue: "Almost always", value: "1" },
  { displayValue: "Quite often", value: "2" },
  { displayValue: "Rarely", value: "3" },
  { displayValue: "Almost never", value: "4" }
];

export const FeelingExhausted = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    console.log(v);
    onNextStep?.();
    onTrackEvent?.(v.displayValue);
    localStorage.setItem(SOMATIC_KEYS.feelingExhaussted, v.value);
  };
  return (
    <OptionsWithBackground
      data={data}
      title="How frequently do you find yourself feeling exhausted?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
